import { Selector } from "./selectors"

export const InventoryConfigurationSelector = Selector


// WEBPACK FOOTER //
// ./src/state/inventory/configuration/selectors/index.ts